import { type ComponentProps } from 'react';

import AkAutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';
import type { AutoDismissFlagProps } from '@atlaskit/flag/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const AutoDismissFlag: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AutoDismissFlagProps &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<ComponentProps<typeof AkAutoDismissFlag>>(AkAutoDismissFlag);
